import { useState, useEffect } from 'react';
import { collection, query, orderBy, onSnapshot, addDoc, updateDoc, doc, deleteDoc } from 'firebase/firestore';
import { db } from '../lib/firebase';
import { PTS } from '../types';
import { toast } from 'react-hot-toast';

export function usePTS() {
  const [ptsList, setPtsList] = useState<PTS[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const q = query(collection(db, 'pts'), orderBy('createdAt', 'desc'));
    
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const ptsData = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      })) as PTS[];
      
      setPtsList(ptsData);
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  const addPTS = async (ptsData: Omit<PTS, 'id' | 'createdAt' | 'updatedAt'>) => {
    try {
      const now = new Date().toISOString();
      await addDoc(collection(db, 'pts'), {
        ...ptsData,
        createdAt: now,
        updatedAt: now
      });
      toast.success('PTS criado com sucesso!');
    } catch (error) {
      console.error('Erro ao criar PTS:', error);
      toast.error('Erro ao criar PTS');
      throw error;
    }
  };

  const updatePTS = async (id: string, ptsData: Partial<PTS>) => {
    try {
      await updateDoc(doc(db, 'pts', id), {
        ...ptsData,
        updatedAt: new Date().toISOString()
      });
      toast.success('PTS atualizado com sucesso!');
    } catch (error) {
      console.error('Erro ao atualizar PTS:', error);
      toast.error('Erro ao atualizar PTS');
      throw error;
    }
  };

  const deletePTS = async (id: string) => {
    try {
      await deleteDoc(doc(db, 'pts', id));
      toast.success('PTS removido com sucesso!');
    } catch (error) {
      console.error('Erro ao remover PTS:', error);
      toast.error('Erro ao remover PTS');
      throw error;
    }
  };

  return {
    ptsList,
    loading,
    addPTS,
    updatePTS,
    deletePTS
  };
}